import {createAction, createReducer, on, props} from '@ngrx/store';
import {StateStatus} from "../../../shared/models/state-status.models";
import {
  cancelUserInvite, cancelUserInviteFailure, cancelUserInviteSuccess,
  inviteUser, inviteUserFailure,
  inviteUserSuccess,
  loadInvitedUsers,
  loadInvitedUsersFailure,
  loadInvitedUsersSuccess
} from "./user-invite.action";
import {UserInvite} from "../../../shared/models/user-invite.model";
import {Role} from "../../../shared/models/role.model";


export interface UserInviteState {
  userInvites: UserInvite[];
  roleDropDownData: Role[];
  error: string | null;
  userInviteStatus: StateStatus;
  roleDropDownStatus: StateStatus;
}

export const initialState: UserInviteState = {
  userInvites: [],
  roleDropDownData: [],
  error: null,
  userInviteStatus: 'pending' as StateStatus,
  roleDropDownStatus: 'pending' as StateStatus,
};

export const userInviteReducer = createReducer(
  initialState,
  on(loadInvitedUsers, (state) : UserInviteState => ({ ...state, userInviteStatus: 'loading' as StateStatus })),
  on(loadInvitedUsersSuccess, (state, { userInvites }) : UserInviteState => ({
    ...state,
    userInvites: userInvites,
    error: null,
    userInviteStatus: 'loadSuccess' as StateStatus,
  })),
  on(loadInvitedUsersFailure, (state, { error }) : UserInviteState => ({
    ...state,
    error: error,
    userInviteStatus: 'error' as StateStatus,
  })),
  on(inviteUser, (state, { userInvite }): UserInviteState => ({
    ...state,
    userInviteStatus: 'adding' as StateStatus,
  })),
  on(inviteUserSuccess, (state, { userInvite }) : UserInviteState => ({
    ...state,
    userInviteStatus: 'addSuccess' as StateStatus,
  })),
  on(inviteUserFailure, (state, { error }) : UserInviteState  => ({
    ...state,
    userInvites: state.userInvites,
    error: error,
    userInviteStatus: 'error' as StateStatus,
  })),
  on(cancelUserInvite, (state, { userInviteId }): UserInviteState => ({
    ...state,
    userInviteStatus: 'removing' as StateStatus,
  })),
  on(cancelUserInviteSuccess, (state, { userInvite }) : UserInviteState => ({
    ...state,
    userInviteStatus: 'removeSuccess' as StateStatus,
  })),
  on(cancelUserInviteFailure, (state, { error }) : UserInviteState  => ({
    ...state,
    error: error,
    userInviteStatus: 'removeError' as StateStatus,
  })),

);
